import { Alert, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ColorFilterRalDisclaimers = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <Alert
          sx={{ "> .MuiAlert-message": { color: "#009FE4" } }}
          severity="info"
        >
          <div
            dangerouslySetInnerHTML={{ __html: t("ral_colors_disclaimer_1") }}
          ></div>
        </Alert>
      </Grid>
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <Alert
          sx={{ "> .MuiAlert-message": { color: "#009FE4" } }}
          severity="info"
        >
          {t("ral_colors_disclaimer_2")}
        </Alert>
      </Grid>
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <Alert
          sx={{ "> .MuiAlert-message": { color: "#009FE4" } }}
          severity="info"
        >
          {t("ral_colors_disclaimer_3")}
        </Alert>
      </Grid>
    </>
  );
};
